import { commonTypes } from '@/reports/types';

const WorkTypes = ['work', 'professional', 'current_professional'];
const confidencePercentageThreshold = 98;

export function displayBestMatch(email: commonTypes.Email) {
  const hasBestTag = email.meta ? email.meta.is_best : null;
  return hasBestTag && !email.hidden;
}

export function classifyEmails(emails: commonTypes.Emails) {
  const work = emails.filter((email) => WorkTypes.includes(email.type || ''));
  const notDerived = work.filter((email) => !email?.is_derived);
  const derived = work.filter((email) => email?.is_derived);
  const personal = emails.filter(
    (email) => !WorkTypes.includes(email.type || '')
  );

  return { notDerived, derived, personal };
}

export function calculateConfidencePercentage(confidence: number) {
  const percentage = confidence * 2;

  return percentage >= confidencePercentageThreshold
    ? confidencePercentageThreshold
    : percentage;
}

export function emailsByProfessionalPriority(emails: commonTypes.Emails) {
  const { notDerived, derived, personal } = classifyEmails(emails);

  return [...notDerived, ...derived, ...personal];
}

export function bestPhone(phones: commonTypes.Phones) {
  if (phones.length > 0) {
    const best = phones.find((phone) => phone.meta && phone.meta?.is_best);
    return best || phones[0];
  }

  return null;
}
